import { render, staticRenderFns } from "./AdvancedSdkConfigs.vue?vue&type=template&id=13b249f6&scoped=true&"
import script from "./AdvancedSdkConfigs.vue?vue&type=script&lang=js&"
export * from "./AdvancedSdkConfigs.vue?vue&type=script&lang=js&"
import style0 from "./AdvancedSdkConfigs.vue?vue&type=style&index=0&id=13b249f6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13b249f6",
  null
  
)

export default component.exports